var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('new-modal-wrapper', {
    ref: "NewRepositionWarningModal",
    attrs: {
      "widthModal": '80%',
      "maxWidthModal": 500,
      "modal-name": "NewRepositionWarningModal",
      "show-close-icon": false,
      "click-to-close": false,
      "cta-primary-button": "repositionReposition"
    },
    on: {
      "before-open": _vm.setSizesInModal,
      "cta-action": _vm.startRepositionFlow
    }
  }, [_c('div', [_c('div', {
    staticClass: "new-modal-error-icon"
  }, [_vm._v("!")]), _c('h2', {
    staticClass: "new-modal-title"
  }, [_vm._v(_vm._s(_vm.translations.repositionHeader))]), _c('p', {
    staticClass: "new-modal-description"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.repositionSubHeader) + "\n      ("), _c('span', [_vm._v(_vm._s(this.contentProps.prevUGCSize))]), _vm._v(")\n      " + _vm._s(_vm.translations.repositionSubHeader2) + "\n      ("), _c('span', [_vm._v(_vm._s(this.contentProps.newUGCSize))]), _vm._v(")\n      " + _vm._s(_vm.translations.repositionSubHeader3) + "\n    ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }